import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import ProcurementPoliciesCreateForm from './ProcurementPoliciesCreateForm';

function ProcurementPoliciesCreate(props) {
    return <ProcurementPoliciesCreateForm indexUrl={policiesIndexUrl} storeUrl={policiesStoreUrl} />;
}

export default ProcurementPoliciesCreate;

if (document.getElementById('procurementPoliciesCreate')) {
    var root = document.getElementById('procurementPoliciesCreate');
    ReactDOM.render(
        <App>
            <ProcurementPoliciesCreate />
        </App>,
        root,
    );
}
